import React, { useContext, useState, useRef, useEffect } from "react";
import ReactDOM from 'react-dom';
import { useTranslation } from "react-i18next";
import { Card } from "react-bootstrap"
import { IconButton } from "@fluentui/react";
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import { getGridLocalization, isNullUndefined, isNullUndefinedOrEmpty, showMessage } from "../../common/Helpers";
import MessageBox from "../../components/Common/Message/MessageBox";
import { __MessageTypes } from "../../common/Dictionaries";
import MainAppContext from "../../MainAppContext";
import MatrixToolbar from "../../components/Products/sPrivilege/Matrix/MatrixToolbar";
import * as XLSX from 'xlsx';
import { applyFilters, handlerFilter, setterActionFired, useFilterActionComponentData } from "../../common/Helpers/JqxGridFilter";
import { getIntegrationconfig as getItem, addIntegrationconfigList as addListItems, addIntegrationconfig as addItem, saveIntegrationConfig as saveItem, deleteIntegrationconfig as deleteItem} from "../../services/sIntegration/integration.service";
import { useGetAllIntegrationconfig as useGetAllItems } from "../../hooks/services/sIntegration/useOfIntegration";
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
import { forEach } from "lodash-es";
import { useGetContractsMaintainer } from "../../hooks/services/sBook/useOfContract";
export default function IntegrationConfig() {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const profileHasAccess = !contextSite.onlyObserver || (contextSite.securityProps.isSAdmin ||  contextSite.securityProps.isAdmin)

    const gridRef = useRef();
    const fileInputRef = useRef(null);

    const [showRequiredGlobalMessage, setShowRequiredGlobalMessage] = useState(false);
    const [editingRows, setEditingRows] = useState([]);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [listItems, setListItems] = useState(null);    
    useGetAllItems(listItems, setListItems);

    const [listElements, setlistElements] = useState(null);    
    useGetContractsMaintainer(listElements, setlistElements)
    
    useFilterActionComponentData(gridRef, messageConfig, "IntegrationConfig");

    const handlerAddNewRow = (obj) => {
        const records = gridRef.current.props.source.records;
        const _lowerId = records.length !== 0 ? records.reduce((min, obj) => obj.id < min ? obj.id : min, records[0].id) : 0;
        const lowerId = records.length === 0 ? -1 : (_lowerId > 0 ? ((_lowerId * -1) - 1) : _lowerId -1);

        const newRow = !obj ? {
            id:             lowerId,            
            module:           0,
            elementId:        0,
            elementNemo:      '',
            internalCode:     '',
            externalCode:     '',
            integrated:       false,
            integratedDate:   ''    
        } : {
            id:             lowerId,
            module:           obj.module,
            elementId:        obj.elementId,
            elementNemo:      obj.elementNemo,
            internalCode:     obj.internalCode,
            externalCode:     obj.externalCode,
            integrated:       obj.integrated,
            integratedDate:   obj.integratedDate
        };

        gridRef.current.beginupdate();
        gridRef.current.addrow(null, newRow, 'first');

        listItems.unshift(newRow);
        setListItems(listItems);

        if (editingRows.length > 0 ? editingRows.find(x => x === lowerId) === undefined : true) {
            editingRows.push(lowerId);
            setEditingRows(editingRows);
        }

        gridRef.current.endupdate();
        gridRef.current.updatebounddata('rows');
        setterActionFired("IntegrationConfig", 1);
    };
    
    const getValue = (column, row) => {
        if (!column.editorOptions) {
            return row[column.dataField] ?? "";
        }

        const rowValue = row[column.dataField];

        const itemValue = column.editorOptions.find(x =>
            String(x.key) === String(rowValue) ||
            String(x.id) === String(rowValue) ||
            String(x.elementCode) === String(rowValue) ||
            String(x.internalCode) === String(rowValue) ||
            String(x.contractCode) === String(rowValue) ||
            String(x.text) === String(rowValue)
        );

        return !isNullUndefinedOrEmpty(itemValue) ? itemValue.text : "";
    }

    const handlerExportData = (exportData) => {
        const workbook = XLSX.utils.book_new();
        const columns = getColumns()
        const aux_rows = []

        if (exportData) {
            const aux_list = listItems.filter(x => x.id > 0);

            aux_list.forEach(row => {
                let aux_row = {};
                columns.forEach(column => {
                    if (column.exportable) {
                        if (column.columntype === 'dropdownlist') {
                            aux_row[column.dataField] = row[column.dataField] !== null ? getValue(column, row) : "";
                        }
                        else {
                            aux_row[column.dataField] = row[column.dataField];
                        }
                    }
                });
    
                aux_rows.push(aux_row);
            });
        }

        const worksheet = XLSX.utils.json_to_sheet(aux_rows, { header: columns.filter(x => (exportData ? x.exportable : x.uploadMasive)).map(column => column.dataField) });
        
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
        XLSX.writeFile(workbook, 'IntegrationConfig_ExportedData.xlsx');
    };

    const handlerUploadData = () => {
        
    };

    const isInValidFormControls = (list) => {
        let isInvalidForm = false;
        const validItems = [];

        list.forEach(element => {
            if (validateObject(element)) {
                validItems.push(element);
            }
            else {
                isInvalidForm = true;
            }
        });
    
        return {isInvalidForm: isInvalidForm, validItems: validItems};
    };
    
    const handlerSaveAll = async () => {
        const elementosFiltrados = listItems.filter(objeto => editingRows.includes(objeto.id));

        const valid_response = isInValidFormControls(elementosFiltrados);

        if (valid_response.validItems) {
            const aux_items = valid_response.validItems.map(({ boundindex, uid, uniqueid, visibleindex, ...rest }) => rest);

            await addListItems(aux_items).then(async (response) => {
                if (response.data.succeeded) {
                    setEditingRows([]);
                    setListItems(response.data.data);
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                }
                setterActionFired("IntegrationConfig", 1);
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                setterActionFired("IntegrationConfig", 1);
            });
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'));
        }
    };

    const handlerSave = async (itemId) => {       
        const item = gridRef.current.props.source.records.find(x => parseInt(x.id) === itemId);

        if (validateObject(item)) {
            if (item.id <= 0) {                

                await addItem(item).then(async (serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        setEditingRows(editingRows.filter(x => x !== item.id));

                        listItems.forEach(element => {
                            if (element.id === parseInt(item.id)) {
                                element.id = serviceResponse.data.data.id;
                                element.module = serviceResponse.data.data.module;
                                element.elementId = serviceResponse.data.data.elementId;
                                element.elementNemo = serviceResponse.data.data.elementNemo;
                                element.internalCode = serviceResponse.data.data.internalCode;
                                element.externalCode = serviceResponse.data.data.externalCode;
                                element.integrated = serviceResponse.data.data.integrated;
                                element.integratedDate = serviceResponse.data.data.integratedDate;     
                                element.integrationConfigCode = serviceResponse.data.data.integrationConfigCode;     
                            }
                        });
                                               
                        setListItems(listItems);
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                    }        
                    setterActionFired("IntegrationConfig", 1);
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                    setterActionFired("IntegrationConfig", 1);
                });
            }
            else {
                await saveItem(item.id, item).then(async (serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        setEditingRows(editingRows.filter(x => x !== item.id));

                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                    }  
                    setterActionFired("IntegrationConfig", 1);
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                    setterActionFired("IntegrationConfig", 1);
                });
            } 

            setShowRequiredGlobalMessage(false);
        }
        else {
            setShowRequiredGlobalMessage(true);
        }
    };

    const handlerDelete = async (itemId) => {        
        if (itemId <= 0) {
            const newListItems = gridRef.current.props.source.records.filter(x => x.id.toString() !== itemId.toString());
            setListItems(newListItems);
            setEditingRows(editingRows.filter(x => x.toString() !== itemId.toString()));
        }
        else {
            await deleteItem(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {                    
                    const newListItems = gridRef.current.props.source.records.filter(x => x.id.toString() !== itemId.toString());

                    setListItems(newListItems);
                    setEditingRows(editingRows.filter(x => x.toString() !== itemId.toString()));
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                    
                    gridRef.current.updatebounddata('rows');                   
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                }
                setterActionFired("IntegrationConfig", 1);
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                setterActionFired("IntegrationConfig", 1);
            });
        }
    };

    const handlerCancel = async (itemId) => {
        if (itemId === null) {
            const newListItems = listItems.filter(x => x.id !== itemId);
            setListItems(newListItems);
            setEditingRows(editingRows.filter(x => x !== itemId));
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));    
            setterActionFired("IntegrationConfig", 1);
        }
        else
        {
            await getItem(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    listItems.forEach(element => {
                        if (serviceResponse.data.data.id === element.id) {
                            for (const property in serviceResponse.data.data) {
                                element[property] = serviceResponse.data.data[property];
                            }
                        }
                    });
            
                    setListItems(listItems);
                    setEditingRows(editingRows.filter(x => x !== itemId));
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                }
                setterActionFired("IntegrationConfig", 1);
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                setterActionFired("IntegrationConfig", 1);
            });
        }
    };

    const validateObject = (object) => {
        let isValid = object.elementId !== undefined && object.elementId !== null && object.elementId > 0;
        isValid = isValid ? (object.module !== undefined && object.module !== null && object.module !== 0 && object.module !== '') : isValid;
        isValid = isValid ? object.internalCode !== undefined && object.internalCode !== null && object.internalCode !== '' : isValid;
        isValid = isValid ? object.externalCode !== undefined && object.externalCode !== null && object.externalCode !== '' : isValid;

        return isValid;
    };

    const getRowIdFromRowIndex = (rowIndex) => {

        try {
            console.log(gridRef.current.props.source.records);
        } catch (error) {
            
        }

        if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
            return listItems[rowIndex.boundindex]?.id;
        }
        return listItems[rowIndex]?.id;
    };

    const normalizeCode = (value) => {
        return String(value ?? '').trim().toUpperCase();
    };

    const getElementCode = (element) => {
        return element?.elementCode ?? element?.internalCode ?? element?.contractCode ?? element?.code ?? '';
    };

    const getUsedElementCodes = (currentRowId = null) => {
        const rows = listItems ?? [];

        return new Set(
            rows
                .filter(row => currentRowId === null || String(row.id) !== String(currentRowId))
                .map(row => normalizeCode(row.internalCode))
                .filter(code => code !== '')
        );
    };

    const getAvailableElementsForRow = (rowIndex) => {
        const rowData = gridRef.current?.getrowdata
            ? gridRef.current.getrowdata(rowIndex)
            : listItems?.[rowIndex];

        const fallbackRowData = listItems?.[rowIndex];
        const currentRow = rowData ?? fallbackRowData;

        const currentRowId = currentRow?.id ?? null;
        const currentCode = normalizeCode(currentRow?.internalCode);
        const usedCodes = getUsedElementCodes(currentRowId);

        return (listElements ?? []).filter(element => {
            const elementCode = normalizeCode(getElementCode(element));

            if (elementCode === '') {
                return false;
            }

            // Mantiene disponible el valor actual de la fila que se está editando.
            if (elementCode === currentCode) {
                return true;
            }

            // Oculta los códigos que ya están seleccionados en otras filas.
            return !usedCodes.has(elementCode);
        });
    };

    const getDropdownElementCode = (rawValue, currentRow) => {
        if (rawValue === undefined || rawValue === null || rawValue === '') {
            return currentRow?.internalCode ?? '';
        }

        if (typeof rawValue === 'object') {
            if (rawValue.value !== undefined && rawValue.value !== null) {
                return rawValue.value;
            }

            if (rawValue.elementCode !== undefined && rawValue.elementCode !== null) {
                return rawValue.elementCode;
            }

            if (rawValue.internalCode !== undefined && rawValue.internalCode !== null) {
                return rawValue.internalCode;
            }

            if (rawValue.contractCode !== undefined && rawValue.contractCode !== null) {
                return rawValue.contractCode;
            }

            if (rawValue.originalItem?.elementCode !== undefined && rawValue.originalItem?.elementCode !== null) {
                return rawValue.originalItem.elementCode;
            }

            if (rawValue.originalItem?.internalCode !== undefined && rawValue.originalItem?.internalCode !== null) {
                return rawValue.originalItem.internalCode;
            }

            if (rawValue.originalItem?.contractCode !== undefined && rawValue.originalItem?.contractCode !== null) {
                return rawValue.originalItem.contractCode;
            }

            if (rawValue.originalItem?.value !== undefined && rawValue.originalItem?.value !== null) {
                return rawValue.originalItem.value;
            }

            if (rawValue.key !== undefined && rawValue.key !== null) {
                const foundByKey = listElements?.find(x =>
                    String(x.key) === String(rawValue.key) ||
                    String(x.id) === String(rawValue.key)
                );

                return getElementCode(foundByKey) || currentRow?.internalCode || '';
            }

            if (rawValue.id !== undefined && rawValue.id !== null) {
                const foundById = listElements?.find(x =>
                    String(x.key) === String(rawValue.id) ||
                    String(x.id) === String(rawValue.id)
                );

                return getElementCode(foundById) || currentRow?.internalCode || '';
            }
        }

        const foundByTextOrCode = listElements?.find(x =>
            normalizeCode(x.text) === normalizeCode(rawValue) ||
            normalizeCode(getElementCode(x)) === normalizeCode(rawValue)
        );

        if (foundByTextOrCode) {
            return getElementCode(foundByTextOrCode);
        }

        return rawValue;
    };

    const onCellvaluechanged = (e) => {
        const rowIndex = e.args.rowindex;
        const dataField = e.args.datafield;
        const value = e.args.value;

        const currentRow = listItems[rowIndex];

        if (!currentRow) {
            return;
        }

        const copia_listItems = JSON.parse(JSON.stringify(listItems));

        if (dataField === 'internalCode') {
            const elementCode = getDropdownElementCode(value, currentRow);

            const selectedElement = listElements?.find(x =>
                normalizeCode(getElementCode(x)) === normalizeCode(elementCode)
            );

            copia_listItems[rowIndex].internalCode = selectedElement
                ? getElementCode(selectedElement)
                : elementCode;

            copia_listItems[rowIndex].elementId = selectedElement
                ? selectedElement.key
                : currentRow.elementId;

            copia_listItems[rowIndex].elementNemo = selectedElement
                ? selectedElement.elementNemo
                : currentRow.elementNemo;
        }
        else {
            copia_listItems[rowIndex][dataField] = value;
        }

        setListItems(copia_listItems);

        const rowId = copia_listItems[rowIndex].id;

        if (editingRows.find(x => x === rowId) === undefined) {
            setEditingRows([...editingRows, rowId]);
        }
        else {
            setEditingRows([...editingRows]);
        }

        applyFilters(gridRef, 'IntegrationConfig', false);

        try {
            const position = gridRef.current.scrollposition();
            const minimalScrollIncrement = 1;

            gridRef.current.scrolloffset(0, position.left + minimalScrollIncrement);
            gridRef.current.scrolloffset(0, position.left - minimalScrollIncrement);
        } catch (error) {

        }
    };

    const actionCellsRenderer = (row) => {        
        const itemId = getRowIdFromRowIndex(row);
        const isEditing = editingRows.find(x => x === itemId);
        
        return  <>
                    {isEditing ? (
                        <>
                            {
                                itemId <= 0 ? (
                                    <>
                                        <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                        <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                    </>
                                ) : (
                                    <>
                                        <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                        <IconButton iconProps={{ iconName: 'Cancel' }} title="Cancelar" ariaLabel="Cancelar" onClick={() => fieldActionHandler(itemId, 'cancel')} />
                                        <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                    </>
                                )
                            }
                        </>
                    ) : (
                        <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                    )}
                </>
    };

    const fieldActionHandler = (itemId, actionType) => {
        switch (actionType) {
            case 'save':
                handlerSave(itemId);
                break;
            case 'delete':
                handlerDelete(itemId);
                break;
            case 'cancel':
                handlerCancel(itemId);
                break;
            default:
                break;
        }
    };

    const cellsRenderer = (rowIndex, cellValue, editor, cellText, width, height, auxListData, cellType, subType) => {
        switch (cellType) {
            case 'textbox':
                switch (subType) {
                    case "currency":
                        editor.jqxNumberInput({
                            decimalDigits: 3,
                            width: width,
                            spinButtons: false,
                            symbol: '$',
                            groupSeparator: ',',
                            decimalSeparator: '.',
                        });
                        break;
                    case "number":
                        editor.jqxNumberInput({
                            decimalDigits: 3,
                            width: width,
                            spinButtons: true,
                            groupSeparator: ',',
                            decimalSeparator: '.',
                        });
                        break;
                    default:
                        break;
                }
                break;
            case 'datetimeinput':
                break;
            case 'checkbox':
                editor.jqxCheckBox({ width: width });
                break;
            case 'dropdownlist':
                const valueMember = subType === 'elementCode' ? 'elementCode' : 'key';
                const listData = auxListData ?? [];

                editor.jqxDropDownList({
                    width: width,
                    height: height,
                    source: getListColumnAdapter(listData, valueMember, 'text'),
                    displayMember: 'text',
                    valueMember: valueMember,
                    autoDropDownHeight: listData.length < 5
                });
                break;
            default:
                break;
        }
    };

    const getListColumnAdapter = (listObjetcs, key, text) => {
        const keyType = key === 'key' || key === 'id' ? 'number' : 'string';

        return new jqx.dataAdapter({
            datafields: [
                { name: text, type: 'string' },
                { name: key, type: keyType }
            ],
            datatype: 'array',
            localdata: listObjetcs ?? []
        }, { autoBind: true });
    };

    const cellRenderClassStyle = (row, columnfield, value, columnType) => {
        let className = "";
        switch (columnType) {
            case "blocked":
                className = 'jqx-custom-blocked';
                break;
            case "textbox":
                if (value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "numberinput":
                if (value < 0 || value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "datetimeinput":
                if (value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "dropdownlist":
                if (value === null || value === '' || value === 0) {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break
            default:
                break;
        }

        return className;
    };
    
    const getColumns = () => {
        const basicColumns =[
            { index: null, text: 'Id',  dataField: 'id', width: '0px', hidden: true, exportable: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) => cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'), columntype: 'textbox', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'), editable: profileHasAccess ?? false, pinned: true},
            { index: null, text: t('data-lang-lbl-actions'),           dataField: 'acciones',       width: '7%',  exportable: false,  pinned: true, filterable: false,
                createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                initwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); }
            },
            { index: 0, text: t('data-lang-lbl-field-module'),                dataField: 'module',                width: '15%', exportable: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'), columntype: 'textbox',       cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'blocked'), editable: false, pinned: true},
            { index: 1, text: t('data-lang-lbl-field-integrationConfigCode'), dataField: 'integrationConfigCode', width: '10%', exportable: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'), columntype: 'numberinput',   cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'blocked'), editable: false, pinned: true },
            {
                index: 2,
                text: t('data-lang-lbl-field-elementNemo'),
                dataField: 'elementNemo',
                width: '14%',
                exportable: true,
                createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>
                    cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'),
                columntype: 'textbox',
                cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'blocked'),
                editable: false
            },
            {
                index: 3,
                text: t('data-lang-lbl-field-internalCode'),
                dataField: 'internalCode',
                width: '17%',
                exportable: true,
                createeditor: (rowIndex, cellValue, editor, cellText, width, height) => {
                    const availableElements = getAvailableElementsForRow(rowIndex);

                    cellsRenderer(
                        rowIndex,
                        cellValue,
                        editor,
                        cellText,
                        width,
                        height,
                        availableElements,
                        'dropdownlist',
                        'elementCode'
                    );
                },
                initeditor: (rowIndex, cellValue, editor) => {
                    const availableElements = getAvailableElementsForRow(rowIndex);
                    const source = getListColumnAdapter(availableElements, 'elementCode', 'text');

                    editor.jqxDropDownList({
                        source: source,
                        displayMember: 'text',
                        valueMember: 'elementCode',
                        autoDropDownHeight: availableElements.length < 5
                    });

                    const currentRow = gridRef.current?.getrowdata
                        ? gridRef.current.getrowdata(rowIndex)
                        : listItems?.[rowIndex];

                    const currentCode = currentRow?.internalCode ?? cellValue;

                    if (currentCode) {
                        editor.jqxDropDownList('selectItem', currentCode);
                    }
                },
                geteditorvalue: (row, cellvalue, editor) => {
                    const selectedItem = editor.jqxDropDownList('getSelectedItem');

                    if (selectedItem && selectedItem.value !== undefined && selectedItem.value !== null) {
                        return selectedItem.value;
                    }

                    return cellvalue;
                },
                columntype: 'dropdownlist',
                editable: profileHasAccess,
                displayfield: 'internalCodeDisplay',
                editorOptions: listElements,
                cellclassname: (row, columnfield, value) =>
                    cellRenderClassStyle(row, columnfield, value, 'dropdownlist'),
                cellsalign: 'left'
            },
            { index: 4, text: t('data-lang-lbl-field-externalCode'),          dataField: 'externalCode',          width: '17%', exportable: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'), columntype: 'textbox',       cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'), editable: profileHasAccess, cellsalign: 'right' },
            { index: 5, text: t('data-lang-lbl-field-integrated'),            dataField: 'integrated',            width: '10%', exportable: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'checkbox', 'string'),columntype: 'checkbox',      editable: profileHasAccess },
            { index: 6, text: t('data-lang-lbl-field-integratedDate'),        dataField: 'integratedDate',        width: '10%', exportable: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'datetimeinput'),     columntype: 'datetimeinput', editable: profileHasAccess, cellsformat: 'dd-MM-yyyy - HH:mm:ss', cellsalign: 'right' },
        ]

        return basicColumns;
    };

    return (
        <div className="col-12 listWithActions h-100">
            <Card className="h-100">
                <Card.Header>
                    <Card.Title className="d-flex justify-content-between">
                        <h4><b>{t('data-lang-maintainer-title-IntegrationConfig')}</b></h4>
                    </Card.Title>
                </Card.Header>
                <Card.Footer>
                    <MessageBox
                        inputParam_Message={ messageConfig.message }
                        inputParam_Display={ messageConfig.showMessage }
                        inputParam_MessageType={ messageConfig.messageType }
                        inputParam_SetterMessage={ setMessageConfig }
                    />
                </Card.Footer>
                <Card.Body className="access-per-month-form-body h-100 overflow-hidden-deprecated">
                    <div className="align-items-center h-100">
                        <div className="d-none">                                                        
                            <a id="btnGetTemplateJson" href={undefined} download="Template.csv" style={{display: "none"}} rel="noreferrer noopener" target='_blank'>#</a>
                        </div>
                        {
                            listItems &&
                            <>
                                <MatrixToolbar
                                    inputParam_HandleSaveData={handlerSaveAll}                                    
                                    inputParam_HandleUploadData={handlerUploadData}
                                    inputParam_HandleExportData={handlerExportData}
                                    inputParam_HandleAddRow={handlerAddNewRow}
                                    inputParam_Configuration={{
                                        buttons: {
                                            showRowButtons: false,
                                            showExportData: profileHasAccess,
                                            showAddMasiveData: false,
                                            showAddData: profileHasAccess,
                                            showDownloadTemplate: false,
                                            showSaveAllData: profileHasAccess,
                                            groupedButtons: false
                                        },
                                        handlers: {
                                            handlerSave: profileHasAccess ? handlerSave : null,
                                            handlerSaveAll: profileHasAccess ? handlerSaveAll : null,
                                            handlerDelete: profileHasAccess ? handlerDelete : null,
                                            handlerCancel: profileHasAccess ? handlerCancel : null,
                                        },
                                        auxiliarListCallbackOnAdd: null,
                                    }}
                                    inputParam_ExternalExportTemplates={[
                                        {
                                            id: 'btnMantGetTemplate',
                                            key: 'btnMantGetTemplate',
                                            text: t('data-lang-lbl-uploadtemplate'),
                                            iconProps: { iconName: 'ExcelDocument' },
                                            onClick: () => handlerExportData(false)
                                        }
                                    ]}
                                    showRequiredMessage={showRequiredGlobalMessage}
                                />
                                {
                                    !isNullUndefined(listElements) &&
                                    <JqxGrid
                                        ref={gridRef}
                                        altrows={false}
                                        enabletooltips={true}
                                        width={'100%'}
                                        theme={'light'} 
                                        editable={true}
                                        height={"550px"}
                                        sortable={true}
                                        filterable={true}
                                        showfilterrow={true} 
                                        localization={getGridLocalization(t)}
                                        source={ new jqx.dataAdapter({
                                            localdata: listItems,
                                            datatype: 'array',
                                            datafields: [            
                                                { name: 'id',                    type: 'int'    },
                                                { name: 'module',                type: 'string' },
                                                { name: 'integrationConfigCode', type: 'string' },
                                                { name: 'elementId',             type: 'number' },
                                                { name: 'internalCode',          type: 'string' },
                                                { name: 'externalCode',          type: 'string' },
                                                { name: 'integrated',            type: 'bool'   },
                                                { name: 'integratedDate',        type: 'date'   },
                                                { name: 'elementNemo',           type: 'string' },
                                                { name: 'internalCodeDisplay', value: 'internalCode', values: { source: listElements, value: 'elementCode', name: 'text' } },
                                            ],
                                            id: 'id'
                                        })}
                                        columns={getColumns()}
                                        onCellvaluechanged={onCellvaluechanged} 
                                        onFilter={(event) => handlerFilter(event, 'IntegrationConfig')}
                                    />
                                }
                            </>
                        }
                    </div>
                </Card.Body>
            </Card>           
        </div>
    ); 
}

